import { $applyNodeReplacement } from "lexical";
import { SurveyAnswersComponent } from "./survey-answers-component";
import { SurveyAnswersNode } from "./survey-answers-node";

import type { SerializedSurveyAnswersNode } from "./types";
import type { DOMConversionMap } from "lexical";

export class SurveyAnswersNodeMui extends SurveyAnswersNode {
  decorate(): React.JSX.Element {
    return (
      <SurveyAnswersComponent
        nodeKey={this.__key}
        questionBold={this.__questionBold}
        questionItalic={this.__questionItalic}
        questionUnderline={this.__questionUnderline}
        questionColor={this.__questionColor}
        answerBold={this.__answerBold}
        answerItalic={this.__answerItalic}
        answerUnderline={this.__answerUnderline}
        answerColor={this.__answerColor}
      />
    );
  }

  static importJSON(serializedNode: SerializedSurveyAnswersNode): SurveyAnswersNodeMui {
    return super.importJSON(serializedNode);
  }

  exportJSON(): SerializedSurveyAnswersNode {
    return super.exportJSON();
  }

  static clone(node: SurveyAnswersNodeMui): SurveyAnswersNodeMui {
    return super.clone(node);
  }

  static getType(): string {
    return super.getType();
  }

  static importDOM(): DOMConversionMap | null {
    return null;
  }
}

export function $createSurveyAnswersNode(headless: boolean, surveyId = ""): SurveyAnswersNode {
  return $applyNodeReplacement(
    headless ? new SurveyAnswersNode(surveyId) : new SurveyAnswersNodeMui(surveyId),
  );
}
